import request from 'store/common/utils';
export const getExchangeApi = (currency) => request({
    url: `/currencies/${currency}/rates`,
    method: 'GET',
});
